import React from 'react';

const MessageIcon = ({ onClick, unreadCount }) => {
  return (
    <button className="header-message-btn" onClick={onClick} title="Messages">
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
        <path d="M12 3C6.48 3 2 6.58 2 11c0 2.13 1.02 4.07 2.68 5.49-.17.84-.68 2.1-2.15 3.38 0 0 3.24-.27 5.56-1.87.61.12 1.26.19 1.91.19 5.52 0 10-3.58 10-8S17.52 3 12 3z" />
      </svg>
      {unreadCount > 0 && (
        <span className="message-badge">
          {unreadCount > 99 ? '99+' : unreadCount}
        </span>
      )}
    </button>
  );
};

export default MessageIcon;
